import React from 'react';
import styled from 'styled-components';


/*

Props:


*/

const StyledDiv = styled.div`
  display: flex;
  align-items: start;
  padding-bottom: 18px;
  order: ${props => props.moduleOrder ? props.moduleOrder : 0};
`;

const ModuleItemContainer = ({ styles, onClick, children, ...rest}) => (
  <StyledDiv style = {styles}  onClick = {onClick} {...rest}>
      { children }
  </StyledDiv>
)

export default ModuleItemContainer


// WEBPACK FOOTER //
// ./src/js/components/ModuleList/ModuleItemContainer.jsx